import { render, staticRenderFns } from "./ItemAnchor.vue?vue&type=template&id=1e8b86c6"
import script from "./ItemAnchor.vue?vue&type=script&lang=js"
export * from "./ItemAnchor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports